/**
 * Helper functions for MVR (Motor Vehicle Record) related operations
 */

/**
 * Checks if there are MVR reports that need to be run
 * @param {Object} store - The MobX store containing offer data
 * @param {boolean} dirty - Whether the form is dirty
 * @param {Object} values - The form values object
 * @returns {Object} Object containing MVR check results
 */
export const getMVRCheckStatus = (store, dirty, values) => {
  // only when the auto is actually being bound: 'HB' (home with bundle discount) never includes 'A',
  // and an 'HA' selection with noBindAuto binds the home only
  const hasPostBindMVrs =
    !dirty &&
    values?.selectedOption &&
    values.selectedOption.includes('A') &&
    !values?.noBindAuto &&
    values?.drivers?.some((driver) => driver.postBindMVR);

  const hasMVRToRun = hasPostBindMVrs || store?.offer?.skippedDataPulls?.includes('drivers-violations');
  const hasOnlyMVRToRun = hasMVRToRun && store?.offer?.skippedDataPulls?.length === 1;
  const hasAtLeastMVRToPull = hasMVRToRun && store?.offer?.skippedDataPulls?.length > 1;

  return {
    hasMVRToRun,
    hasPostBindMVrs,
    hasOnlyMVRToRun,
    hasAtLeastMVRToPull
  };
};

// Non-MVR reports clear these and nothing defers them again. Adding a car or driver afterwards only
// re-defers auto pulls (carfax, drivers-violations).
const HOME_REPORT_PULLS = ['home-claims', 'roof-year', 'cape-analytics', 'remove-unverified-rc1-values'];

export const haveHomeReportsRun = (skippedDataPulls) =>
  !skippedDataPulls?.some((pull) => HOME_REPORT_PULLS.includes(pull));
